/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Swift_Bird_BurnInputs */

const en_quiet_swift_bird_burn = /** @type {(inputs: Quiet_Swift_Bird_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detractors`)
};

const de_quiet_swift_bird_burn = /** @type {(inputs: Quiet_Swift_Bird_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detraktoren`)
};

/**
* | output |
* | --- |
* | "Detractors" |
*
* @param {Quiet_Swift_Bird_BurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_swift_bird_burn = /** @type {((inputs?: Quiet_Swift_Bird_BurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Swift_Bird_BurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_swift_bird_burn(inputs)
	return de_quiet_swift_bird_burn(inputs)
});